export default [
  {
    name: 'expoIndex',
    path: '/expo/index/:id',
    meta: { title: '加载中...' },
    component: () =>
      import(/* webpackChunkName: "expoIndex" */ '../../pages/expo/Index')
  },
  {
    name: 'expoPayStatus',
    path: '/expo/index/:id/success',
    meta: { title: '支付成功' },
    component: () =>
      import(/* webpackChunkName: "expoPayStatus" */ '../../pages/expo/Success')
  },
  {
    name: 'expoTicket',
    path: '/expo/ticket/:id',
    meta: { title: '我的票券' },
    component: () =>
      import(/* webpackChunkName: "expoTicket" */ '../../pages/expo/Ticket')
  },
  {
    name: 'expoShareTicket',
    path: '/expo/shareTicket/:id',
    meta: { title: '加载中...' },
    component: () =>
      import(
        /* webpackChunkName: "expoShareTicket" */ '../../pages/expo/ShareTicket'
      )
  },
  {
    name: 'expoGetTicket',
    path: '/expo/getTicket/:id',
    meta: { title: '领取票券' },
    component: () =>
      import(
        /* webpackChunkName: "expoGetTicket" */ '../../pages/expo/GetTicket'
      )
  },
  {
    name: 'expoGetStatus',
    path: '/expo/getTicket/:id/success',
    meta: { title: '领取成功' },
    component: () =>
      import(/* webpackChunkName: "expoGetStatus" */ '../../pages/expo/Success')
  },
  {
    name: 'expoProduct',
    path: '/expo/product/:prodId',
    meta: { title: '加载中...' },
    component: () =>
      import(/* webpackChunkName: "expoProduct" */ '../../pages/expo/Product')
  },
  {
    name: 'expoExhibit',
    path: '/expo/expoExhibit/:id',
    meta: { title: '加载中...' },
    component: () =>
      import(/* webpackChunkName: "expoExhibit" */ '../../pages/expo/Exhibitor')
  }
]
